import React from 'react';

/**
 * Route-level lazy import that can never hand `React.lazy` an `undefined`
 * module.
 *
 * `chunkReloadGuard` calls `preventDefault()` on Vite's `vite:preloadError`
 * so a stale-deploy chunk failure reloads the page instead of throwing. With
 * the default prevented, Vite's preload helper swallows the error and the
 * dynamic `import()` RESOLVES WITH `undefined`; `React.lazy` then reads
 * `.default` of undefined and the whole root unmounts a beat before
 * `location.reload()` lands (ORDER-THISWAY-21: 49 events / 46 users in 90d,
 * blank flashes included mid-checkout).
 *
 * A module of `undefined` only ever means "the guard is already reloading",
 * so the correct state is *pending*: Suspense keeps its fallback on screen
 * until the reload replaces the document.
 *
 * Exported only so `lazyRoute.test.jsx` can pin those two behaviours; nothing
 * outside this module imports it.
 */
export const lazyRoute = (load) =>
  React.lazy(() => load().then((module) => module ?? new Promise(() => {})));

export const publicRoutes = [
  {
    key: 'home',
    path: '/home',
    component: lazyRoute(() => import('../../views/home/index')),
    authority: [],
  },
  {
    key: 'terms',
    path: '/terms',
    component: lazyRoute(() => import('../../views/terms/index')),
    authority: [],
  },
  {
    key: 'privacy',
    path: '/privacy',
    component: lazyRoute(() => import('../../views/privacy/index')),
    authority: [],
  },
  {
    key: 'store',
    path: '/:storeSlug',
    component: lazyRoute(() => import('../../views/store/index')),
    authority: [],
  },
  {
    key: 'product',
    path: '/:storeSlug/:productId',
    component: lazyRoute(() => import('../../views/product/index')),
    authority: [],
  },
  {
    key: 'payment-process',
    path: '/:storeSlug/payment/process',
    component: lazyRoute(() => import('../../views/payment/Process')),
    authority: [],
  },
  {
    key: 'success',
    path: '/:storeSlug/success',
    component: lazyRoute(() => import('../../views/success/Success')),
    authority: [],
  },
];

export const authRoutes = [
  {
    key: 'login',
    path: '/:storeSlug/login',
    component: lazyRoute(() => import('../../views/auth/Login')),
    authority: [],
  },
  // Auth
  {
    key: 'login',
    path: '/login',
    component: lazyRoute(() => import('../../views/auth/Login')),
    authority: [],
  },
  {
    key: 'forgot-password',
    path: '/forgot-password',
    component: lazyRoute(() => import('../../views/auth/forgot-password')),
    authority: [],
  },
];

export const protectedRoutes = [
  {
    key: 'complete',
    path: '/:storeSlug/complete',
    component: lazyRoute(() => import('../../views/auth/complete')),
    authority: [],
  },
  {
    key: 'complete',
    path: '/complete',
    component: lazyRoute(() => import('../../views/auth/complete')),
    authority: [],
  },
  {
    key: 'user-profile',
    path: `/user/profile`,
    component: lazyRoute(() => import('../../views/user/Profile')),
    authority: [],
  },
  {
    key: 'user-orders',
    path: `/user/orders`,
    component: lazyRoute(() => import('../../views/user/Orders')),
    authority: [],
  },
  {
    key: 'user-favorites',
    path: `/user/favorites`,
    component: lazyRoute(() => import('../../views/user/Favorites')),
    authority: [],
  },
  {
    key: 'order-detail',
    path: `/user/order/:orderId`,
    component: lazyRoute(() => import('../../views/order/OrderDetail')),
    authority: [],
  },
  {
    key: 'payment',
    path: '/:storeSlug/payment',
    component: lazyRoute(() => import('../../views/payment/Payment')),
    authority: [],
  },
];
